// extracted by mini-css-extract-plugin
module.exports = {"theme":"#2C51EF"};